import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';

import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import ValidationLegacyStrings from '@bingads-webui-clientcenter/validation-legacy-strings';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { ValidatedInput } from '@bingads-webui-react/validation-controls';

import { PropTypeI18n } from './shapes';

const formatCurrency = (i18n, num) => i18n.formatDecimal(num, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const getRangePlaceholder = ({ min, max }, i18n) => (min <= max ?
  `${formatCurrency(i18n, min)} - ${formatCurrency(i18n, max)}` :
  null);

const AmountInputUnwrapped = ({
  paymentAmount,
  setPaymentAmount,
  max,
  min,
  i18n,
  required,
  alwaysShowError,
}) => {
  const validationI18n = useMemo(() => buildLegacyI18n(i18n, ValidationLegacyStrings), [i18n]);

  return (
    <LineByLineFormGroup label={i18n.getString(_TL_('Add funds to your balance'))} >
      <ValidatedInput
        className="form-control"
        key={`${min}-${max}`}
        placeholder={getRangePlaceholder({ min, max }, i18n)}
        validationProps={{
          onValidate: useCallback(({ data }) => setPaymentAmount(data.paymentAmount), [setPaymentAmount]),
          field: 'paymentAmount',
          data: { paymentAmount },
          alwaysShowError,
          schema: {
            properties: {
              paymentAmount: {
                type: 'number',
                required,
                minimum: min,
                maximum: max,
                decimalLength: 2,
              },
            },
          },
          i18n: validationI18n,
        }}
      />
    </LineByLineFormGroup>
  );
};

AmountInputUnwrapped.propTypes = {
  paymentAmount: PropTypes.number,
  setPaymentAmount: PropTypes.func.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  i18n: PropTypeI18n.isRequired,
  required: PropTypes.bool.isRequired,
  alwaysShowError: PropTypes.bool,
};

AmountInputUnwrapped.defaultProps = {
  paymentAmount: null,
  alwaysShowError: false,
};

export const AmountInput = memo(AmountInputUnwrapped);
